import { FC } from 'react';
import { Form, Select } from 'antd';

import classes from './index.module.css';

interface OptionInputInterface {
	label: string;
	value: string;
}

interface SelectInputInterface {
	name: string;
	label: string;
	rules?: any;
	placeholder?: string;
	options?: Array<OptionInputInterface>;
	onChange?: (value: string) => void;
	onSearch?: (value: string) => void;
	disabled?: boolean;
	loading?: boolean;
}

const SelectInput: FC<SelectInputInterface> = ({
	name,
	label,
	rules,
	placeholder,
	options,
	onChange,
	onSearch,
	disabled,
	loading,
}) => {
	const { Option } = Select;
	return (
		<Form.Item name={name} label={label} rules={rules} className={classes['select-input-box']}>
			<Select
				placeholder={placeholder}
				onChange={onChange}
				onSearch={onSearch}
				disabled={disabled}
				loading={loading}
				showSearch
				optionFilterProp="children"
				filterOption={onSearch ? false : undefined}
			>
				{options?.map((opt, index) => {
					return (
						<Option key={`${opt.value}-${index}`} value={opt.value}>
							{opt.label}
						</Option>
					);
				})}
			</Select>
		</Form.Item>
	);
};

export default SelectInput;
